function toggleAccordion(id) {
  const accordionItem = document.getElementById(id);
  if (!accordionItem) {
    return;
  }
  const accordionItemIsOpen = accordionItem.classList.contains('accordions__item--collapsed');
  if (accordionItemIsOpen === true) {
    accordionItem.classList.remove('accordions__item--collapsed');
  } else {
    accordionItem.classList.add('accordions__item--collapsed');
  }
}
function toggleSidebarDropdown(id) {
  const dropdownItemToggle = event.target;
  const dropdownItem = document.getElementById(id);
  if (!dropdownItem || !dropdownItemToggle) {
    return;
  }
  const dropdownItemClosed = dropdownItem.classList.contains('hidden');
  if (dropdownItemClosed === true) {
    dropdownItem.classList.remove('hidden');
    dropdownItemToggle.classList.add('open');
  } else {
    dropdownItem.classList.add('hidden');
    dropdownItemToggle.classList.remove('open');
  }
}